/**
 * RealEstateUserEvents
 * Registry of events for the Real Estate pages
 */
export enum RealEstateUserEvents {
    ClickGoogleMapsLink = "Real Estate - Click Google Maps Link",
}
